import { Injectable } from '@angular/core';
import { API_CONSTANT, SERVICE_CONSTANT } from '../../shared/utils/api.constant';
import { HttpClient } from '@angular/common/http';
import { UpdateUserPayload, UpdateUserResponse, UpdateUserStatusResponse, User, UserDetail, UserList } from '../interfaces/user.model';
import { map, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  tokenExpired$: Subject<boolean> = new Subject<boolean>();

  constructor(private http: HttpClient) { }

  refreshToken() {
    return this.http.post<any>(
      `${SERVICE_CONSTANT.AUTHENTICATION}${API_CONSTANT.REFRESH_TOKEN}`,
      { refreshToken: localStorage.getItem('refreshToken') }
    );
  }


  getUserDetails(roleId: number, companyId: number) {
    return this.http.get<User[]>(`${SERVICE_CONSTANT.AUTHENTICATION}${API_CONSTANT.GET_CLIENT_DETAILS_BY_ROLE}${roleId}/${companyId}`);
  }

  addUser(payload: any) {
    return this.http.post(`${SERVICE_CONSTANT.AUTHENTICATION}${API_CONSTANT.ADD_USER}`, payload);
  }

  getRoles(type: string) {
    return this.http.get<any[]>(`${SERVICE_CONSTANT.AUTHENTICATION}${API_CONSTANT.GET_ROLE}/${type}`);
  }

  getAllUserRole() {
    return this.http.get<any[]>(`${SERVICE_CONSTANT.AUTHENTICATION}${API_CONSTANT.GET_ALL_USERS_ROLE}`);
  }

  UserList(data: any) {
    return this.http.get<any>(`${SERVICE_CONSTANT.AUTHENTICATION}${API_CONSTANT.GET_USER}?pageSize=${data.pageSize}&pageNumber=${data.pageNumber}&searchTerm=${data.searchTerm}`);
  }

  getCompany(type: string) {
    return this.http.get<any[]>(`${SERVICE_CONSTANT.PROJECTMANAGEMENT}${API_CONSTANT.GET_COMPANY}`);
  }

  getUsersByRole(role: number) {
    return this.http.get<User[]>(`${SERVICE_CONSTANT.AUTHENTICATION}${API_CONSTANT.GET_USERS_BY_ROLE}${role}`);
  }

  getCurrentUser() {
    return this.http.get<UserList[]>(`${SERVICE_CONSTANT.AUTHENTICATION}${API_CONSTANT.GET_CURRENT_USER}`);
  }

  updateUserProfile(user: any) {
    return this.http.post<UserList[]>(`${SERVICE_CONSTANT.AUTHENTICATION}${API_CONSTANT.UPDATE_USER_PROFILE}`, user);
  }

  // Super Admin only. A 200 is not always a save — check success / requiresConfirmation in the body
  updateUser(id: number, payload: UpdateUserPayload) {
    return this.http.put<UpdateUserResponse>(`${SERVICE_CONSTANT.AUTHENTICATION}${API_CONSTANT.UPDATE_USER}${id}`, payload);
  }

  // Activate / deactivate (Users.isActive), active Super Admin only; Super Admin accounts cannot be deactivated
  updateUserStatus(id: number, isActive: boolean) {
    return this.http.put<UpdateUserStatusResponse>(
      `${SERVICE_CONSTANT.AUTHENTICATION}${API_CONSTANT.UPDATE_USER_STATUS}${id}`,
      { isActive }
    );
  }

  getUserById(id: number) {
    return this.http.get<any>(`${SERVICE_CONSTANT.AUTHENTICATION}${API_CONSTANT.GET_USER}/${id}`);
  }

  // Edit User prefill: GET users/get/:id answers with a bare array, [] for an unknown user → null
  getUserForEdit(id: number): Observable<UserDetail | null> {
    return this.getUserById(id).pipe(
      map((res: any) => (Array.isArray(res) ? res[0] : res?.data ?? res) ?? null)
    );
  }

  getClientViewDetails(id: number) {
    return this.http.get<any>(`${SERVICE_CONSTANT.PROJECTMANAGEMENT}${API_CONSTANT.GET_CLIENT_VIEW_DETAILS}${id}`);
  }
}
